import m from 'mithril'

export default m.trust(`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 6.00001L5.94862 7.31623C7.17364 7.72458 7.99992 8.87099 7.99992 10.1623V14M2 6.00001L3.5 9.5M2 6.00001L5 4" stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 13V13C8 9.8174 9.26428 6.73572 11.5147 4.48528L14 2M14 2L11 2M14 2V4.92188" stroke="white" stroke-opacity="0.4" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`)
